import { SVGProps } from "react";

export const AtlassianMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M11.0669 15.0399C10.7061 14.6431 10.165 14.6792 9.91249 15.1481L4.06816 26.8729C3.8517 27.3419 4.17637 27.883 4.68144 27.883H12.8347C13.0872 27.883 13.3397 27.7387 13.448 27.4862C15.2157 23.8425 14.1334 18.3229 11.0669 15.0399Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M15.3613 4.36124C12.0783 9.55622 12.2948 15.2923 14.4594 19.6215C16.6239 23.9506 18.2835 27.2336 18.3917 27.4861C18.4999 27.7386 18.7524 27.8829 19.005 27.8829H27.1582C27.6633 27.8829 28.024 27.3418 27.7715 26.8728C27.7715 26.8728 16.8044 4.93846 16.5157 4.39732C16.2993 3.89225 15.686 3.85618 15.3613 4.36124Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
